module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-circle-fill-664dbd3c.svg";